
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Axios from '../../../axios/axios';
import SupplierNavbar from "./SuppplierNavbar";
import SupplierSidebar from "./SupplierSidebar";

function SupplierSingleOrder() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [supplier, setSupplier] = useState(null);
 const [sidebarOpen, setSidebarOpen] = useState(true);
  
  

  useEffect(() => {
    const fetchOrder = async () => {
      const storedSupplier = sessionStorage.getItem("supplierInfo");
      if (!storedSupplier) {
        setError("Supplier information not found");
        setLoading(false);
        return;
      }

      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);

      try {
        

        

        const response = await Axios.get(`/supplier/${supplierInfo.supplierId}/orders/${orderId}`);

        setOrder(response.data.order);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch order details");
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId]);




  

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">{error}</div>
        <button 
          className="btn btn-secondary" 
          onClick={() => navigate(-1)}
        >
          &larr; Back
        </button>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="container mt-4">
        <div className="alert alert-warning">Order not found</div>
        <button 
          className="btn btn-secondary" 
          onClick={() => navigate(-1)}
        >
          &larr; Back
        </button>
      </div>
    );
  }


return (
  <div className="enhanced-body">
    <SupplierNavbar 
      supplier={supplier}
      toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
    />
    
    <div className="container-fluid">
      <div className="row">
        {sidebarOpen && (
          <div className="col-md-2">
            <SupplierSidebar />
          </div>
        )}
        
        <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
          <div className="dashboard-main">
            <div className="container mt-4">
                <div className="card p-4 " style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                  <h4>Order Details</h4>
                  
                  <p><strong>Order Number:</strong> {order.orderNumber}</p>
                  {/* <p><strong>Customer Name:</strong> {order.customerName}</p> */}
                  <p><strong>Order Date:</strong> {new Date(order.orderDate).toLocaleDateString()}</p>
                  <p><strong>Delivery Date:</strong> {order.deliveryDate ? new Date(order.deliveryDate).toLocaleDateString() : 'Not specified'}</p>
                  <p><strong>Order Status:</strong> 
                    {order.orderStatus}
                  </p>
                  <p><strong>Payment Status:</strong> {order.paymentStatus || 'Not specified'}</p>
                  <p><strong>Your Amount:</strong> AED{order.total?.toFixed(2) || '0.00'}</p>
                  
                  <h5 className="mt-4">Your Products</h5>
                  <ul className="list-group mb-4">
                    {order.orderItems.map((item) => (
                      <li key={item.productId} className="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{item.productName}</strong>
                        </div>
                        <div>
                          {item.quantity} × AED{item.unitPrice.toFixed(2)} = AED{(item.quantity * item.unitPrice).toFixed(2)}
                        </div>
                      </li>
                    ))}
                  </ul>

                  <div className="d-flex justify-content-between">
                    <button 
                      className="btn btn-secondary" 
                      onClick={() => navigate(-1)}
                      style={{ minWidth: '100px' }}
                    >
                      &larr; Back
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
}



export default SupplierSingleOrder
